import React from 'react';
import HomeSection from '../components/Homepage/HomeSection';

const HomePage: React.FC = () => {
  return (
    <div className="mb-8">
      <HomeSection />
    </div>
  );
};

export default HomePage;
